module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-800"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "问题",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "解决方案",
      "prop": "value"
    }
  }, [_c('SquillEditorQiniu', {
    attrs: {
      "token": _vm.qiniuForm.token,
      "content": _vm.form.value,
      "domain": _vm.qiniuForm.domain,
      "uploadUrl": _vm.uploadUrl
    },
    model: {
      value: (_vm.form.value),
      callback: function($$v) {
        _vm.$set(_vm.form, "value", $$v)
      },
      expression: "form.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9f1b357c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/robot/edit.vue
// module id = 1868
// module chunks = 2